module.exports = __webpack_public_path__ + "img/ic_share_cancle.fc07b0f5.svg";